import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styles: []
})
export class MaintenancePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
